import React from "react";
import { TituloTabla } from "../../shared/Estilos";
import { clienteAxios, useLog, Swal } from "../../shared/";
import Documentacion from "./Documentacion";

const ListarDocumentaciones = ({
  lista,
  openModal,
  setSeleccionado,
  setConsultar,
  soloLectura
}) => {

  const [InsertarLog] = useLog(null);

  const borrar = async (id) => {
    try {
      await clienteAxios.delete("/personasdocumentacion", {
        params: { id },
      });
      InsertarLog( "eliminar", "Eliminacion de Documentacion");
      setConsultar(true);
    } catch (e) {
    }
  };

  const editar = (item) => {
    setSeleccionado(item);
    openModal();
  };

  const eliminar = (item) => {
    Swal.fire({
      title: "Esta Seguro que desea Eliminar?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, Eliminar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
        //console.log(item.id);
        borrar(item.id);
      }
    });
  };

  return (
    <div className="table-responsive">
      <table className="table table-striped" style={{backgroundColor:"white"}}>
        <TituloTabla>
          <tr>
            <th scope="col" className="text-center">
            Descripcion
            </th>
            <th scope="col" className="text-center">
            Archivo
            </th>
            <th scope="col" className="text-center">
              Acciones
            </th>
          </tr>
        </TituloTabla>
        <tbody>
          {lista.map((item) => (
            <Documentacion
              key={item.id}
              item={item}
              editar={editar}
              eliminar={eliminar}
              soloLectura={soloLectura}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ListarDocumentaciones;
